module.exports = __webpack_public_path__ + "img/tencent-active.04ec66bc.jpeg";